/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'townsquare.townsquare-tags.tag': 'Remover marcador',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, one {Usado em {usageCount,number} local} other {Usado em {usageCount,number} locais}}',
};
